import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import InspectionItemPerformed from './inspection-item-performed';
import InspectionItemPerformedDetail from './inspection-item-performed-detail';
import InspectionItemPerformedUpdate from './inspection-item-performed-update';
import InspectionItemPerformedDeleteDialog from './inspection-item-performed-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={InspectionItemPerformedUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={InspectionItemPerformedUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={InspectionItemPerformedDetail} />
      <ErrorBoundaryRoute path={match.url} component={InspectionItemPerformed} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={InspectionItemPerformedDeleteDialog} />
  </>
);

export default Routes;
